import moment from "moment";

export const tableData = [
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: false,
  },
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
];
